<app-page-title title="Mis clientes" description="Revisa la información y operaciones de Factoring con tus clientes.">
</app-page-title>

<div class="button-container button-direction-column">
    <fs-ui-button class="intercom-button-add-client" routerLink="create" [label]="'Nuevo cliente'"></fs-ui-button>
</div>
<app-client-item *ngFor="let client of clients; let i = index" [routerLink]="client._id" [myClient]="client" class="item intercom-item-{{i}}">
</app-client-item>